var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_17955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73221 20.7164C6.1457 20.7164 7.29156 19.5705 7.29156 18.157C7.29156 16.7435 6.1457 15.5977 4.73221 15.5977C3.31871 15.5977 2.17285 16.7435 2.17285 18.157C2.17285 19.5705 3.31871 20.7164 4.73221 20.7164Z",
    fill: "#909BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1994 18.4466C22.4262 18.4466 23.4207 17.452 23.4207 16.2252C23.4207 14.9984 22.4262 14.0039 21.1994 14.0039C19.9725 14.0039 18.978 14.9984 18.978 16.2252C18.978 17.452 19.9725 18.4466 21.1994 18.4466Z",
    fill: "#C8D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1709 7.24326C20.1844 7.24326 21.006 6.4217 21.006 5.40825C21.006 4.3948 20.1844 3.57324 19.1709 3.57324C18.1575 3.57324 17.3359 4.3948 17.3359 5.40825C17.3359 6.4217 18.1575 7.24326 19.1709 7.24326Z",
    fill: "#E9EDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71606 14.4686C4.21609 14.4686 5.43211 13.2823 5.43211 11.8188C5.43211 10.3553 4.21609 9.16895 2.71606 9.16895C1.21602 9.16895 0 10.3553 0 11.8188C0 13.2823 1.21602 14.4686 2.71606 14.4686Z",
    fill: "#7E8B96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5185 23.9996C11.8821 23.9996 12.9876 22.9224 12.9876 21.5935C12.9876 20.2647 11.8821 19.1875 10.5185 19.1875C9.15479 19.1875 8.04932 20.2647 8.04932 21.5935C8.04932 22.9224 9.15479 23.9996 10.5185 23.9996Z",
    fill: "#A2ABB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 22.9459C18.1597 22.9459 19.2099 21.9233 19.2099 20.6619C19.2099 19.4005 18.1597 18.3779 16.8642 18.3779C15.5687 18.3779 14.5186 19.4005 14.5186 20.6619C14.5186 21.9233 15.5687 22.9459 16.8642 22.9459Z",
    fill: "#B9C3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65443 8.31486C7.22263 8.31486 8.49391 7.07393 8.49391 5.54317C8.49391 4.01241 7.22263 2.77148 5.65443 2.77148C4.08622 2.77148 2.81494 4.01241 2.81494 5.54317C2.81494 7.07393 4.08622 8.31486 5.65443 8.31486Z",
    fill: "#5F6C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.901 12.5132C23.0601 12.5132 23.9998 11.591 23.9998 10.4534C23.9998 9.31578 23.0601 8.39355 21.901 8.39355C20.7419 8.39355 19.8022 9.31578 19.8022 10.4534C19.8022 11.591 20.7419 12.5132 21.901 12.5132Z",
    fill: "#DCE6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 5.98793C14.3535 5.98793 15.694 4.64748 15.694 2.99396C15.694 1.34044 14.3535 0 12.7 0C11.0465 0 9.70605 1.34044 9.70605 2.99396C9.70605 4.64748 11.0465 5.98793 12.7 5.98793Z",
    fill: "#4E5A61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_17955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingIcon);
export default __webpack_public_path__ + "static/media/saving_icon.5ba432a86b3f9700cac9b5e071f26c39.svg";
export { ForwardRef as ReactComponent };